module.exports = __webpack_public_path__ + "img/logo-qualiopi.e85d55c.png";